/**
 * Ownership check for cards drawn by another app.
 *
 * raftor_websitehq renders its own product cards (one batched fetch, one paint)
 * and stamps `data-rfhq-owned="1"` on the container it manages. Two scripts in
 * this app are deliberately page-agnostic — product_variant_swatches.js and
 * listing_quantity.js — so they would otherwise find those cards and decorate
 * them a second time, on top of markup that already carries the feature.
 *
 * An attribute rather than a pathname check, because a websitehq block can
 * appear on any page, including /all-products.
 *
 * Degrades safely in both directions: with websitehq absent nothing is ever
 * marked and this always returns false, so every script behaves exactly as it
 * did before. Setting `window.rfhqProductCardOwnership = false` on the
 * websitehq side stops the marker being written at all, which is the kill
 * switch — no deploy needed to fall back.
 */
(function () {
	'use strict';

	window.webhqOwnedSurface = function (node) {
		if (!node || typeof node.closest !== 'function') return false;
		return Boolean(node.closest('[data-rfhq-owned]'));
	};
})();
